import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Object.values';
import 'promise-polyfill/src/polyfill';
import { momentifyDate } from '../../shared/js/dateUtils';

//filter
$('.filter__item').click(function () {
  $('.filter__item').removeClass('active');
  $(this).addClass('active');
  if (!$(this).hasClass('select-more')) {
    $('input[name="type_group"]').val($(this).data('value'));
  } else {
    $(this).attr('data-value', $('#dropdown-search-bar-item').val());
    $('input[name="type_group"]').val($('#dropdown-search-bar-item').val());
  }
});
$(document).ready(function(){
  $('.car-search-form').on('submit', function() {
    const splitPickupDate = $('input[name="_pickup_at"]').val();
    const splitDeliveryDate = $('input[name="_delivery_at"]').val();
    const pickupDate = momentifyDate(splitPickupDate).format('YYYY-MM-DD');
    const deliveryDate = momentifyDate(splitDeliveryDate).format('YYYY-MM-DD');
    $('input[name="pickup_at"]').val(pickupDate);
    $('input[name="delivery_at"]').val(deliveryDate);
  });
});

$('#dropdown-search-bar-item').change(function () {
  $('.filter__item').removeClass('active');
  $('.select-more').addClass('active');
  $('.select-more').attr('data-value', $('#dropdown-search-bar-item').val());
  $('input[name="type_group"]').val($('#dropdown-search-bar-item').val());
});

//autocomplete
var $postal = $('[name="postal"]');
$postal.autocomplete({
  serviceUrl: window.citySearchUrl,
  type: 'GET',
  minChars: 2,
  // onSearchStart: function (queryObj) {
  //     query = queryObj.query;
  // },
  onSelect: function (suggestion) {
    $postal.val(suggestion.value);
    $("select[name='_pickup_at']").focus();
  }
});

function initFromDatepicker(minDate, defaultDate) {
  window.fromDate = flatpickr('.car-search-form input[name="_pickup_at"]', {
    locale: {
      ...appLocale,
      firstDayOfWeek: weekStartDay,
    },
    // mode: "range",
    dateFormat: phpDateFormat,
    minDate: minDate,
    defaultDate: defaultDate,
    disableMobile: "true",
    weekNumbers: true,
    onChange: (selectedDates) => {
      if (selectedDates[0]) {
        var defaultToDate = selectedDates[0].fp_incr(1);
        if (selectedDates[0] < window.toDate.selectedDates[0]) {
          defaultToDate = window.toDate.selectedDates[0];
        }
        if (window.toDate.selectedDates.length === 0) {
          defaultToDate = null;
        }

        window.toDate.destroy();

        initToDatepicker(selectedDates[0].fp_incr(1), defaultToDate);
      } else {
        initToDatepicker(new Date().fp_incr(1), window.TO_DATE);
      }
      if (window.toDate && window.toDate.selectedDates.length === 0) {
        window.toDate.destroy();
        initToDatepicker(selectedDates[0].fp_incr(1), null);
      }
      window.toDate.set('minDate', (selectedDates[0] || new Date()).fp_incr(1));
      window.toDate.redraw();
    }
  });
}

function initToDatepicker(minDate, defaultDate) {
  window.toDate = flatpickr('.car-search-form input[name="_delivery_at"]', {
    locale: {
      ...appLocale,
      firstDayOfWeek: weekStartDay,
    },
    // mode: "range",
    dateFormat: phpDateFormat,
    minDate: minDate,
    defaultDate: defaultDate,
    disableMobile: "true",
    weekNumbers: true,
    onChange: (selectedDates) => {
      if (selectedDates[0] && selectedDates[0] <= window.fromDate.selectedDates[0]) {
        window.fromDate.destroy();
        initFromDatepicker('today', selectedDates[0].fp_incr(-1));
        window.fromDate.redraw();
      }
      if (!selectedDates[0]) {
        initFromDatepicker('today', window.FROM_DATE);
      }
    }
  });
}

//calendar
if ($('.car-search-form [name="_pickup_at"]').length && $('.car-search-form [name="_delivery_at"]').length) {
  initFromDatepicker('today', window.FROM_DATE);
  let initialDate = new Date().fp_incr(1);
  if (window.fromDate.selectedDates[0]) {
    initialDate = window.fromDate.selectedDates[0].fp_incr(1);
  }

  initToDatepicker(initialDate, window.TO_DATE);
}

$('.locations .read-more').on('click', function (e) {
  e.preventDefault();
  const $cars = $(this).siblings('.car-items').find('.car-box:hidden');
  let hideButton = false;
  if ($cars.length <= 6) {
    hideButton = true;
  }

  for (let i = 0; i < 6; i++) {
    $($cars[i]).show();
  }

  if (hideButton) {
    $(this).hide();
  }
});
